module.exports = __webpack_public_path__ + "avatar_all.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/landing/avatar_all.png
// module id = 1728
// module chunks = 11